module.exports = {
      id: "nav-icon-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "images/js_src_vue/common/sprite.61ac148b.svg#nav-icon-usage",
      toString: function () {
        return this.url;
      }
    }